
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M51.971 48.14c-.3-.9-.4-.6-1.1-1.2-1.7-1.3-3.9-1.6-5.6-3.2-4-3.6-6-8.6-6.6-13.9-.4-3-.3-6.1 0-9.1.2-2.3 1.2-5.1 1.1-7.4-.1-2.1-1.5-3.3-3.6-4-6.6-2-6.3 5.3-7.2 9.3-.5 2.2-1.2 4.4-2.1 6.5-.2.5-1 3-1.7 3.2-.8.2-.9-1.2-1.3-2.3-.8-2.3-1.4-4.7-2.2-7 0-.1-.1-.2-.1-.3l-.2-.4c-2-3.2-6.9-5.2-10.3-3.5-.4.3-.5 1.2-.5 1.6.2 7.6-2.1 15.1-2.5 22.6-.2 3-.2 6.9 3.1 8.1 4.2 1.5 5.7-1.4 5.3-4.9-.6-4.6-.7-9.2-.9-14v-1.4c.2 1.4.5 2.9.7 4.3.4 3.7.4 9.5 2.8 12.6 2.3 3 6.4 2.2 7.9-.9 1.4-3 1.7-6.4 2.9-9.5 1.6 5.1 3.5 10 7.9 13.4 2.8 2.2 10.4 5.7 13.9 3.5.5-.1.5-1.5.3-2.1zm-21.5-17.9c-.2-.6-.7-1.1-1.1-.3-1.4 2.9-1.8 6.1-2.8 9.1-.5 1.5-.9 2.5-2.4 3-3.1 1.1-4.6-.9-5.3-3.4-1.1-4-1.2-8.2-1.8-12.3-.2-1.5-.3-4.8-1.7-5.8-.1-.1-.2-.1-.4 0-1.4 1.2-.9 4.8-.8 6.3.1 3.9.1 7.9.2 11.8.1 2.5 2.1 6.5-2.2 5.5-4-.9-2.7-5.7-2.3-8.9.8-5.8 2-11.7 2.1-17.6 2.8-1 7.3.7 8.7 3.3 1.2 3.6 2.2 7.3 3.6 10.8.2.4.5.6.8.2 2.8-3 3.9-7.5 4.9-11.3.4-1.5.5-3.1.9-4.5 1.2-4.4 4.2-4.9 7.3-2.5-1.2 7.2-1.8 14.8.2 21.9.8 3.1 2.2 6 4.1 8.5.9 1.1 1.9 2.2 3 3.1-2.6-.7-5.2-2-6.5-2.8-5-3.2-6.8-8.6-8.5-14.1z"}})])
          )
        }
      }
    